import React, { useEffect, useState } from 'react';
import { fetchTenantContext } from '../services/api';
import { setSelectedTenantId } from '@mobile-services/tenantSelection';
import { resetMe } from '../hooks/useMe';
import { Card, Button, Loading, ErrorText, errorMessage } from '../components/ui';

// Shown when an identity holds a seat in more than one tenant (a contractor
// who is a guest in several customers' accounts). The choice is a hint only -
// the server re-checks the seat before honouring the x-tenant-id header.
export default function OrgPickerPage({ onPicked }) {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    // `options` is set when a request was forced to ask; `memberships` lists
    // every seat regardless, for switching org later. The API returns neither
    // under the name `tenants`, which this page used to read - it rendered
    // "No organisations found" for an account that had several, and nothing
    // routed here, so nobody saw it.
    fetchTenantContext()
      .then((ctx) => {
        const list = (Array.isArray(ctx?.options) && ctx.options.length) ? ctx.options : ctx?.memberships;
        setTenants(Array.isArray(list) ? list : []);
      })
      .catch((err) => setError(errorMessage(err)))
      .finally(() => setLoading(false));
  }, []);

  function choose(tenantId) {
    setSelectedTenantId(tenantId);
    // The role is a property of the SEAT, so it only means anything once a
    // tenant is chosen - anything read before this point described no tenant
    // at all, and an owner looked like a member.
    resetMe();
    onPicked?.();
  }

  if (loading) return <Loading text="Loading organisations…" />;

  return (
    <>
      <h1>Choose organisation</h1>
      <p className="sub">Your account has access to more than one organisation.</p>
      <ErrorText>{error}</ErrorText>
      {tenants.map((t) => (
        // `label` is what the API sends; name/planId were never in this shape.
        <Card key={t.tenantId} title={t.label || t.name || t.tenantId}>
          <Button block onClick={() => choose(t.tenantId)}>Continue</Button>
        </Card>
      ))}
      {!tenants.length && !error && <p className="muted">No organisations found for this account.</p>}
    </>
  );
}
